import React from 'react'
import { Box, Button, Container, Grid, MobileStepper, Paper, Typography, useTheme } from '@mui/material'
// import { styled } from '@mui/material/styles';
import { autoPlay } from 'react-swipeable-views-utils';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import SwipeableViews from 'react-swipeable-views';

import banner from '../../../assets/images/banner.jpg'

export default function BannerSection() {
    const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);


    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };


    return (
        <Box sx={{ maxWidth: 650, flexGrow: 1 }}>

            <AutoPlaySwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            >
                <div>
                    <a href="https://www.drivenecosystem.com/blog/drivenswap-v2-0-listing" target='_blank'>
                        <Box
                            component="img"
                            sx={{
                                // minHeight: {lg:190,xl:190},
                                // maxHeight: '300px',
                                // height: '200px',
                                minHeight: { sm: '150px', xs: '150px', md: '200px', lg: '150px' },
                                mt: 1,
                                display: 'block',
                                maxWidth: '750px',
                                // maxWidth: '440px',
                                overflow: 'hidden',
                                width: '100%',
                                borderRadius: '30px'
                            }}
                            src={banner}
                        // alt={step.label}
                        />
                    </a>
                </div>
            </AutoPlaySwipeableViews>

        </Box>
    );
}
